import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { useWorkspace } from '../../stores';
import { dateKey } from '../../../shared/lib/format';
import { listExpenses } from '../api/expensesApi';
export function useExpenses(from: string, to: string, enabled = true) {
  const { isDemo, store, scopeKey, timezone } = useWorkspace(); const demo = useDemo();
  return useQuery({ queryKey: [...scopeKey, 'expenses', from, to, isDemo ? demo.revision : 0], queryFn: async ({ signal }) => (isDemo ? demo.expenses.filter(e => e.store_id === store?.id) : await listExpenses(from,to,signal)).filter(e => dateKey(e.bill_date_ms, timezone) >= from && dateKey(e.bill_date_ms, timezone) <= to), enabled: enabled && Boolean(store?.id), staleTime: 30_000 });
}
